import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-audit-icon',
  imports: [],
  templateUrl: './audit-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './audit-icon.component.scss',
})
export class AuditIconComponent {}
